import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Feather } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { ArticleCard } from "./ArticleCard";
import { api } from "../lib/api";
import { img } from "../lib/images";

const ComingSoon = () => (
  <div className="grid overflow-hidden rounded-[24px] border border-ink/10 bg-white sm:grid-cols-2" data-testid="insights-coming-soon">
    <div className="h-56 overflow-hidden sm:h-auto">
      <img {...img("villa", "(min-width: 640px) 30vw, 100vw")} loading="lazy" decoding="async" alt="Garden villa with pool in Bali" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
    </div>
    <div className="flex flex-col p-7 sm:p-9">
      <span className="grid h-11 w-11 place-items-center rounded-full bg-mint text-ink"><Feather className="h-4 w-4" /></span>
      <h3 className="mt-6 font-display text-2xl text-ink">Coming soon</h3>
      <p className="mt-3 leading-relaxed text-ink/70">We're working on our first articles. Check back soon for hospitality insights from across Bali.</p>
    </div>
  </div>
);

export const Insights = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    api.get("/articles", { params: { limit: 2 } })
      .then((r) => setArticles(Array.isArray(r.data) ? r.data : []))
      .catch(() => setArticles([]));
  }, []);

  return (
    <section id="insights" data-testid="insights-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <div className="grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <Eyebrow>From the desk</Eyebrow>
          <h2 className="font-display text-4xl leading-[1.08] text-ink sm:text-5xl">Latest Insights</h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-ink/70 sm:text-lg">
            Hospitality trends, property management tips, and stories from across Bali's most iconic regions.
          </p>
          <Link to="/insights" data-testid="insights-view-all" className="btn-ghost mt-8">
            View all articles <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          {articles.length === 0 ? <ComingSoon /> : (
            <div className="grid gap-5 sm:grid-cols-2">
              {articles.map((a) => <ArticleCard key={a.id} a={a} />)}
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
};
